import { Col, Container, Row } from "react-bootstrap";
import { Desc, Heading } from "../../Global/Typography";
// AnchorButton,
import { useState } from "react";

import NextArrow from "../../../images/Common/NextArrow.svg";
import PrevArrow from "../../../images/Common/PrevArrow.svg";

import OutdoorSeating1 from "../../../images/SoulTree/ThereIsSomething/OutdoorSeating1.webp";

// import engrace6 from "../../../images/Engrace/outdoorseating/engrace6.webp";
import SwiperCore, {
    A11y,
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import DownloadBrochure from "../../Global/DownloadBrochure";
import "./OutdoorSeating.scss";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const doubleHeightGarden =
    "/images/GreenStoreys/outdoorseating/double-height-garden.jpg";
const inclusiveCommunity =
    "/images/GreenStoreys/outdoorseating/inclusive-community.jpg";
const openLayout = "/images/GreenStoreys/outdoorseating/open-layout.jpg";
const bayWindow = "/images/GreenStoreys/outdoorseating/bay-window.jpg";
const superiorFixtures =
    "/images/GreenStoreys/outdoorseating/superior-fixtures.jpg";

export default function OutdoorSeating({ inView }) {
    const [show, setShow] = useState(false);
    const handleShow = (e) => {
        e.preventDefault();
        setShow(true);
    };
    // console.log(
    //   "🚀 ~ file: OutdoorSeating.js ~ line 31 ~ handleShow ~ handleShow",
    //   handleShow
    // );
    const handleClose = () => setShow(false);

    const OutdoorSeatingData = [
        {
            title: "There is a little something for each member of your family",
            desc: "Area designed to satisfy your outdoor needs and keep you motivated to work and socialize. With the various facilities available at your fingertips, you can enjoy a calm space to work or inspire yourself to break a sweat.",
            // button: "Download Clubhouse Brochure",
            button: "Download Amenities Brochure",
            imageList: [
                {
                    image: doubleHeightGarden,
                    imgAlt: "Double Height Garden",
                    // label: "Soultree Court",
                    title: "Double Height Garden",
                    desc: "Each tower’s 4th floor features a double-height garden, a dedicated recreation zone for residents.",
                    position: "70%",
                },
                {
                    image: inclusiveCommunity,
                    imgAlt: "Inclusive Community",
                    // label: "Kids Play Area",
                    title: "Inclusive Community",
                    desc: "Our community ensures accessibility for all with inclusive ramps, visual signage, and dedicated parking.",
                    position: "40%",
                },
                {
                    image: openLayout,
                    imgAlt: "Open layout",
                    // label: "Sports Area",
                    title: "Open Layout",
                    desc: "Every unit features an open layout to enhance airflow and ensure ample natural light.",
                    position: "60%",
                },
                {
                    image: bayWindow,
                    imgAlt: "Bay Windows",
                    // label: "Sports Area",
                    title: "Bay Windows",
                    desc: "Designed to fill your space with plenty of natural light, creating a bright atmosphere. Selected units only.",
                    position: "60%",
                },
                {
                    image: superiorFixtures,
                    imgAlt: "Superior Fixtures",
                    title: "Superior Fixtures",
                    desc: "Quality and longevity define our fixtures and fittings, offering exceptional value for money and enduring durability.",
                    position: "10%",
                },
            ],
            image: OutdoorSeating1,
            label: "Outdoor seating",
        },
    ];

    return (
        <section
            className={`section bg-white ${inView ? "inView" : "outView"}
    `}
        >
            {OutdoorSeatingData.map((item, idx) => {
                return (
                    <Container
                        key={idx}
                        className="OutdoorSeating OutdoorSeating--small"
                    >
                        <div className="OutdoorSeating__Slider">
                            <Swiper
                                className="OutdoorSeatingSlider"
                                id="OutdoorSeatingSlider"
                                tag="section"
                                wrapperTag="ul"
                                spaceBetween={0}
                                keyboard={{
                                    enabled: true,
                                }}
                                speed={500}
                                loop={true}
                                autoplay={true}
                                pagination={{
                                    clickable: true,
                                    el: ".swiper-pagination-OutdoorSeating",
                                }}
                                navigation={{
                                    prevEl: ".ArrowButtonBlock__ArrowPrevWhite",
                                    nextEl: ".ArrowButtonBlock__ArrowNextWhite",
                                }}
                                onSwiper={(swiper) => console.log(swiper)}
                                // onSlideChange={(swiper) =>
                                //   console.log("slide index changed to: ", swiper.activeIndex)
                                // }
                                onInit={(swiper) =>
                                    console.log("Swiper initialized", swiper)
                                }
                                breakpoints={{
                                    300: {
                                        slidesPerView: 1,
                                        spaceBetween: 30,
                                    },
                                }}
                            >
                                {item.imageList.map((item, index) => (
                                    <SwiperSlide tag="li" key={index}>
                                        <Row className="align-items-center">
                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={6}
                                                xl={5}
                                                className="px-3 px-md-5"
                                            >
                                                <div className="imagePatch">
                                                    <img
                                                        src={item.image}
                                                        className="OutdoorSeating__image w-100 mb-0"
                                                        alt={item.imgAlt}
                                                        style={{
                                                            objectPosition: `${item.position}`,
                                                        }}
                                                    />
                                                    {/* <span className="-label">
                                                        {item.title}
                                                    </span> */}
                                                </div>
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={6}
                                                xl={7}
                                                className="pt-5 pt-md-0 px-4 px-md-5"
                                            >
                                                <Heading
                                                    variant="h1"
                                                    classList="OutdoorSeating__title"
                                                    text={item.title}
                                                />
                                                <Desc
                                                    classList="OutdoorSeating__desc mt-3 mb-5 pb-5"
                                                    text={item.desc}
                                                />
                                                {/* <AnchorButton
                          href="#"
                          classList="OutdoorSeating__btn my-3"
                          text={item.button}
                          onClick={handleShow}
                        /> */}
                                            </Col>
                                        </Row>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <Row className="ArrowButtons pl-md-3">
                                <div className="swiper-pagination swiper-pagination-OutdoorSeating"></div>
                                {/* <div className="swiper-pagination swiper-pagination-OutdoorSeating bg-trans"></div> */}
                                <div className="ArrowButtonBlock">
                                    <div className="ArrowButtonBlock__Arrow ArrowButtonBlock__ArrowPrevWhite">
                                        <img
                                            src={PrevArrow}
                                            className="-image"
                                            alt="Blocks"
                                        />
                                    </div>
                                    <div className="ArrowButtonBlock__Arrow ArrowButtonBlock__ArrowNextWhite">
                                        <img
                                            src={NextArrow}
                                            className="-image"
                                            alt="Blocks"
                                        />
                                    </div>
                                </div>
                            </Row>
                        </div>
                    </Container>
                );
            })}

            {/* DownloadBrochure */}
            <DownloadBrochure
                title={"Download Brochure"}
                show={show}
                handleClose={handleClose}
            />
        </section>
    );
}
